<!-- 
Dialog for deleting an override.

Deleting overrides is normally handled by individual provider tasks, so this is only used 
on the overrides listing to delete a "RemoveProvider" override and bring a provider back into
the levy collection.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog sm">
    <v-card>
      <v-toolbar color="secondary" flat dark>
        <v-toolbar-title>{{ titleForDisplay }}</v-toolbar-title>
      </v-toolbar>
      <our-busy-indicator :show="state.processing"/>
      <v-card-text>{{ prompt }}</v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn :disabled="state.processing" flat @click="hide">Cancel</v-btn>
        <v-btn :disabled="state.processing" :color="buttonColor" flat @click="deleteOverride">
          {{ buttonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as action from "@/store/levy-collection-overrides/action-types";

export default {
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    levyCollectionId: {
      validator: prop => typeof prop === "number" || prop === null,
      required: true
    },
    overrideId: {
      validator: prop => typeof prop === "number" || prop === null,
      default: null
    },
    providerName: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    prompt: {
      type: String,
      default: "Are you sure you want to delete this override?"
    },
    buttonText: {
      type: String,
      default: "Delete"
    },
    buttonColor: {
      type: String,
      default: "error"
    }
  },
  computed: {
    state() {
      return this.$store.state.levyCollectionOverrides.delete;
    },
    titleForDisplay() {
      return this.title ? this.title : `Delete override for ${this.providerName}`;
    }
  },
  methods: {
    async deleteOverride() {
      const succeeded = await this.$store.dispatch(action.EDIT_DELETE, {
        levyCollectionOverrideId: this.overrideId,
        levyCollectionId: this.levyCollectionId
      });
      this.hide();
      if (succeeded) {
        this.$emit("changed");
      }
    },
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
